import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { FAQSection } from '../components/FAQSection';
import { Button } from '../components/ui/button';
import { MessageCircle } from 'lucide-react';

const FAQsPage = () => {
  return (
    <div data-testid="faqs-page" className="bg-white">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="pt-32 pb-16 bg-gradient-to-b from-orange-50 to-white relative overflow-hidden">
          <div className="absolute top-20 right-20 w-72 h-72 bg-yellow-500/10 rounded-full blur-3xl" />
          <div className="section-container relative z-10">
            <span className="inline-block px-4 py-2 bg-yellow-100 text-yellow-700 rounded-full text-sm font-semibold mb-4">
              Help Center
            </span>
            <h1 className="text-4xl md:text-6xl font-bold text-slate-900 font-['Outfit'] mb-6">
              Frequently Asked <span className="text-coral">Questions</span>
            </h1>
            <p className="text-xl text-slate-600 max-w-2xl">
              Find answers to common questions about living at Apollo House. Can't find what you're looking for? Contact us directly.
            </p>
          </div>
        </section>

        {/* All FAQs */}
        <FAQSection showAll={true} />

        {/* Still Have Questions */}
        <section className="section-spacing bg-white">
          <div className="section-container">
            <div className="bg-orange-50 rounded-3xl p-8 md:p-12 text-center border border-orange-100">
              <MessageCircle className="w-16 h-16 text-coral mx-auto mb-6" />
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 font-['Outfit'] mb-4">
                Still Have Questions?
              </h2>
              <p className="text-slate-600 text-lg max-w-xl mx-auto mb-8">
                Our team is here to help. Reach out to us and we'll get back to you as soon as possible.
              </p>
              <Link to="/contact">
                <Button
                  data-testid="faqs-contact-btn"
                  className="bg-gradient-to-r from-coral to-orange hover:from-coral-dark hover:to-coral text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg shadow-coral/25"
                >
                  Contact Us
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default FAQsPage;
